import { useQuery } from '@tanstack/react-query'

import { errorKeys } from '../../../../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { errorService } from '../../../../service/ErrorService'
import { formatTimestampToDateTime } from '../../../../utils/conversion'

function mapErrorByUuidData(data) {
  return {
    uuid: data?.issue?.uuid,
    studentId: data?.issue?.studentId,
    responseEmail: data?.issue?.responseEmail,
    content: data?.issue?.content,
    reportedAt: formatTimestampToDateTime(data?.issue?.reportedAt),
    device: data?.issue?.device,
    trackingList: (data?.trackingList ?? []).map((item) => ({
      id: item?.id,
      timestamp: item?.timestamp,
      tracking_id: item?.tracking_id,
      tracking_action: item?.tracking_action,
      tracking_screen: item?.tracking_screen,
      tracking_param: item?.tracking_param,
    })),
  }
}
export default function useGetErrorByUUID(uuid) {
  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      showLoadingToast(
        'Đang tải chi tiết báo cáo lỗi',
        toastKey.ERROR_REPORTS.DETAIL
      )
      const { success, message } = await errorService.getByUuid(uuid)
      console.log(message, success)
      if (!success) {
        throw new Error(message.content)
      }

      const errorReportData = message?.content
      showSuccessToast(
        'Tải chi tiết báo cáo lỗi thành công',
        toastKey.ERROR_REPORTS.DETAIL
      )
      // return mapErrorByUuidData(errorReportData)
      return errorReportData
    },
    queryKey: errorKeys.detail(uuid), //vì đang fake nên phải xoá đi để call được nhiều
  })

  // if ((error || !data) && !isLoading) {
  //   showErrorToast({
  //     error: error.message,
  //     message: 'Lấy thông tin thất bại, vui lòng liên hệ admin',
  //     toastId: toastKey.ERROR_REPORTS.DETAIL,
  //   })
  // }

  return { data, isLoading }
}
